import { JSX } from 'react';
import { TextField } from '@mui/material';

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}

export default function TextInput({
  value,
  onChange,
  placeholder,
}: Props): JSX.Element {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      inputProps={{ 'data-testid': 'text-input' }}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
